import React from 'react';
import Dispatcher from '../dispatchers/Dispatcher';

export default class ZoneEventOutcomeModal extends React.Component {
    close() {
        Dispatcher.dispatch({ type: 'close-zone-event-outcome-modal' });
    }

    save(outcome) {
        Dispatcher.dispatch({
            type: 'zone-event-outcome-modal-click',
            data: {
                outcome: outcome,
                time: this.props.time
            }
        });
    }

    renderModalText() {
        if (this.props.configuration.zone_entry.track_dump_player && !!this.props.lockedEvent && this.props.lockedEvent.type === "zone_entry") {
            return (
                <div class="text-center" style={{ marginBottom: "10px" }}>
                    <h2>If selecting possession for your team, select the player regaining possession after modals close</h2>
                </div>
            ) 
        }
        return (
            ""
        )
    }

    render() {
        return (
            <div className={`modal-overlay team ${this.props.open ? 'open' : ''}`}>
                <div className="modal-content">
                    <span className="close" onClick={() => this.close()}>&#x2715;</span>
                    <div className="section">
                        <h1>Select Outcome</h1>
                        {this.renderModalText()}
                        <div className="btn-row-6-stack">
                            <div className="btn" onClick={() => this.save('possession')}>
                                <span>POSSESSION</span>
                            </div>
                            <div className="btn" onClick={() => this.save('no_possession')}>
                                <span>NO POSSESSION</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
